var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({class:{
    'mx-2': _vm.iconName !== 'question',
    'ml-2': _vm.iconName === 'question',
  }},_vm.$listeners),[_c('MIcon',{staticClass:"text-neutral",style:({ visibility: _vm.iconName === 'question' ? 'hidden' : 'visible' }),attrs:{"type":"fal","name":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }